module.exports = __webpack_public_path__ + "static/media/bolso (6).71f9d29f.jpg";